import { mutatorAction } from 'satcheljs';
import { FeedbackCategory } from '../components/InlineFeedbackDialog';
import { inlineFeedbackDialogStore } from '../store/store';

/**
 * This will get call when the user choose option from the drop down
 * whithin suggestion
 */

export let setFeedbackSubcategories = mutatorAction(
    'setFeedbackSubcategories',
    (
        optionKey: string,
        optionText: string,
        optionSelected: boolean,
        category: FeedbackCategory
    ) => {
        // find current suggestion and create new category
        let store = inlineFeedbackDialogStore();
        let selectedSubCategories = store.subCategories.get(category.uiString);
        let selectedSubCategory: FeedbackCategory = selectedSubCategories
            .slice()
            .filter(categorise => categorise.logString === optionKey.toString())[0];

        // Based on checkbox was selected or not, add or remove Subcategory.
        if (optionSelected && !selectedSubCategory) {
            selectedSubCategories.push({ logString: optionKey.toString(), uiString: optionText });
        } else {
            selectedSubCategories.remove(selectedSubCategory);
        }
    }
);
